module.exports = __webpack_public_path__ + "static/media/p4_img1.1984e604.png";